import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { AnchorTabOptions } from '../models/anchor-tab-options.interface';
//import { ConfigService } from '../services/config.service';

/**
 * Note: this component relies on updates from EnterTheViewportNotifierDirective
 * 
 * Usage: 
 * <div id="divId"
		(visibilityChange)="anchorTabComponent.visibilityChangeHandler($event)" 
		enterTheViewportNotifier ></div>
		
 */

@Component({
	selector: 'app-anchor-tabs',
	templateUrl: './anchor-tabs.component.html',
	styleUrls: ['./anchor-tabs.component.scss']
})
export class AnchorTabsComponent implements OnInit {

	public activeAnchorTab: string;
	@Input('anchorTabs') anchorTabs: any[];
	@Input('anchorOptions') anchorOptions: AnchorTabOptions;

	public isMobile: boolean = false;
	public isSticky: boolean = false;
	@ViewChild('stickyMenuPositionHolder') menuElementPos: ElementRef;

	public toResize: any;
	public toResizeMs: number = 50;

	constructor(
		//private _configService: ConfigService,
		private scroller: ViewportScroller
	) { }

	ngOnInit(): void {
		// console.log('AnchorTabsComponent.anchorTabs', this.anchorTabs);
		// console.log('AnchorTabsComponent.anchorOptions', this.anchorOptions);
	}

	@HostListener('window:resize', ['$event'])
	onResizeEvent() {
		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			this.updateStickyNav();
		}, this.toResizeMs);
	}


	@HostListener('window:scroll', ['$event'])
	onScrollEvent() {
		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			this.updateStickyNav();
		}, this.toResizeMs);
	}


	/**
	 * Update sticky nav isSticky if menu is above the top
	 * https://medium.com/@chiodigiovanni1/a-simple-on-scroll-sticky-menu-with-angular-and-bulma-66fafc7fc7b9
	 * 
	*/
	 public updateStickyNav() {
		const windowScroll = window.pageYOffset,
			menuPosition = this.menuElementPos.nativeElement.offsetTop;
		//console.log('AnchorTabsComponent.menuPosition', menuPosition);

		
		/**
		 * Warning: Circular dependency detected:
src\app\shared\anchor-tabs\anchor-tabs.component.ts -> src\app\shared\services\config.service.ts -> src\app\shared\shared.module.ts -> src\app\shared\anchor-tabs\anchor-tabs.component.ts
		 */
		//todo: fix circular depedencythis._configService.breakpoints.md
		if(window.innerWidth < 768) {
			this.isMobile = true;
		} else {
			this.isMobile = false
		}

		if(windowScroll >= menuPosition){
			this.isSticky = true;
		} else {
			this.isSticky = false;
		}
	}


	/**
	 * Anchor tab scroll to element
	 * @param id 
	*/
	public scrollTo(id: any){
		//console.log('AnchorTabsComponent.scrollTo.id', id);
		this.scroller.setOffset([0, this.anchorOptions.height + 15]);//height of nav +
		this.scroller.scrollToAnchor(id);
	}


	/**
	 * Visibility change handler comes from directive: enterTheViewportNotifier
	 * @param entry 
	*/
	public visibilityChangeHandler(entry: any) {
		//console.log('AnchorTabsComponent.visibilityChangeHandler.entry', entry);

		if(this.isMobile && this.anchorOptions.hideMobile) return;

		const entryId = entry.target.id,
			isVisible = entry.isIntersecting ? true : false;
			//yPos = entry.boundingClientRect.top;
		//console.log('AnchorTabsComponent.entry: ', entryId, isVisible, yPos);

		//Update visibility property
		const updateEntry = this.anchorTabs.find( ({ id }) => id === entryId );
		updateEntry.isVisible = isVisible;

		//Look for the first visible element
		let foundFirst: boolean = false;
		this.anchorTabs.forEach(anchor => {
			if(anchor.isVisible && !foundFirst) {
				//anchor.isActive = true;
				this.activeAnchorTab = anchor.id;
				//console.log('AnchorTabsComponent.activeAnchorTab:', anchor);
				foundFirst = true;
			}
		});

		//console.log('anchorTabs:', this.anchorTabs);
	}



}
